module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4xADM"))).then(() => parcelRequire('iDabs'));